import { render, staticRenderFns } from "./config-second-ware.vue?vue&type=template&id=03db45d0&scoped=true&"
import script from "./config-second-ware.vue?vue&type=script&lang=ts&"
export * from "./config-second-ware.vue?vue&type=script&lang=ts&"
import style0 from "./config-second-ware.vue?vue&type=style&index=0&module=true&lang=stylus&"
import style1 from "./config-second-ware.vue?vue&type=style&index=1&id=03db45d0&scoped=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "03db45d0",
  null
  
)

export default component.exports